import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dc050c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page d-overflow d-full" }
const _hoisted_2 = { class: "head-warp" }
const _hoisted_3 = { class: "d-flex d-flex-h-center" }
const _hoisted_4 = { class: "user-img" }
const _hoisted_5 = { class: "d-flex-1f" }
const _hoisted_6 = { class: "user-name" }
const _hoisted_7 = {
  key: 0,
  class: "face-auth-btn face-auth-btn-ed"
}
const _hoisted_8 = { class: "statistics-number-warp" }
const _hoisted_9 = { class: "mini" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "剩余积分", -1))
const _hoisted_11 = { class: "statistics-number-warp" }
const _hoisted_12 = { class: "mini" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "获得积分", -1))
const _hoisted_14 = { class: "statistics-number-warp" }
const _hoisted_15 = { class: "mini" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "互助发帖", -1))
const _hoisted_17 = { class: "statistics-number-warp" }
const _hoisted_18 = { class: "mini" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "互助完成", -1))
const _hoisted_20 = { class: "vip-card-warp" }
const _hoisted_21 = { class: "title-warp d-flex" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-label d-flex-1f" }, " 最新互助贴 ", -1))
const _hoisted_23 = { class: "help-item-warp" }
const _hoisted_24 = { class: "help-item-head d-flex" }
const _hoisted_25 = { class: "d-flex-1f" }
const _hoisted_26 = { class: "help-typename" }
const _hoisted_27 = { class: "help-name" }
const _hoisted_28 = { class: "help-point" }
const _hoisted_29 = { class: "help-time" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_31 = { class: "contactNumber-item-wrap" }
const _hoisted_32 = ["href"]

import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { localDataCore } from "@/modular/localData/localData";


import { GetMyNeighborCount, MyNewLoveHelp } from '@/api/MyNeighbor';
import { getTenantUser } from '@/api/userTenantApi';
import { postBeforehandPayNeighborrecharge } from '@/api/NeighborLoveHelpApi';

import RechargeView from "./RechargeView.vue";
import { chooseWXPay } from "@/modular/Weixinh5";
import { payWeJs } from "@/api/Pay";
import { Toast as toast, Dialog } from 'vant';
import { Ref } from "vue";
import { getByCode } from '@/api/AppsettingsApi';



// import faceAuth from "@/components/faceAuth.vue";
// import videoCompress from '@/components/videoCompress.vue';

type pointObj = {
    big: string,
    small: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const RechargeRef = ref();
const router = useRouter();
const orderNav = ref([
    { label: "代付款", ico: "d-shop-to-payment", statusCode: "unpaid" },
    { label: "待发货", ico: "d-shop-to-completed", statusCode: "haveInHand" },
    { label: "已完成", ico: "d-shop-completed", statusCode: "complete" },
    { label: "已取消", ico: "d-shop-cancle", statusCode: "cancelled" },
]);

const userInfo: Ref = ref({
    "id": "",
    "name": "",
    "phone": "",
    "sex": "",
    "headImg": "",
    "token": "",
    "roleName": [] as Array<any>,
    "lockTime": 0,
    "num": 0,
    "idCard": "",
    "province": "",
    "city": "",
    "district": "",
    "address": "",
    "email": "",
    tenantName: "",
    isFaceRecognition: false,
    isIdCardVerfiy: false,
});
// 互助贴
const loveHelp = ref([]);

const myNeighborCount = ref({
    myPoint: {} as pointObj,
    myOrderPoint: {} as pointObj,
    pulishCount: {} as pointObj,
    helpCount: {} as pointObj,

});

function goOrder(navItem) {
    router.push(`/shop/my/order/home/${navItem.statusCode}`);
}
function goMutualAid(loveHelpItem) {
    router.push({
        path: `/mulin/mutualAid/Details/${loveHelpItem.id}`,
        query: {
            helpActType: 2
        }
    });
}
function onLoad() {
    loadLoveHelp();
    loadUserInfo();
    loadMyNeighborCount();
}
async function loadUserInfo() {
    // userInfo.value.img = "cCwuL3AvMjAyMTA4MjQvMTQ0Ny8yLDBlNDNjZGlkLnduMi5qcGc=";
    userInfo.value = await getTenantUser();

}
// 加载互助数据
async function loadLoveHelp() {
    // 这里接口调用
    const response = await MyNewLoveHelp({ pageNum: 1 })

    loveHelp.value = response.rows;

    // 模拟数据
    // loveHelp.value = [
    //     { typeName: '产检陪护', name: '张三', money: 350, time: new Date().getTime() },
    //     { typeName: '作业辅导', name: '李四', money: 210, time: new Date().getTime() },
    //     { typeName: '产检陪护', name: '李四', money: 420, time: new Date().getTime() },
    //     { typeName: '作业辅导', name: '张三', money: 190, time: new Date().getTime() },
    // ];
}
function goPoints() {
    router.push('/mulin/my/Points/home');
}

function goMyUserInfo() {
    router.push(`/mulin/myBaseInfo`);
}

async function loadMyNeighborCount() {
    const response = await GetMyNeighborCount();
    let myNeighborCountObj = {};
    for (let key in response) {
        console.log(key)
        let curVal = String(response[key]);
        /**
         * 把数字拆分开来
         */
        myNeighborCountObj[key] = {
            // big: curVal.slice(0, 2),
            // small: curVal.slice(2, curVal.length),
            big: curVal,
            small: '',
        };

    }
    myNeighborCount.value = myNeighborCountObj as any;
}

function findHelpType(id: string) {
    const arr = localDataCore.helptype;
    const index = arr.findIndex((item: any) => {
        return item.id == id;
    })
    if (index > -1) {
        return arr[index].name;
    }

}

function showAllMutualAid() {
    router.push('/mulin/mutualAid/all')
}

/**
 * 方便把页面统一管理，并且不用写这么多个跳转方法
 */
const pageObj = {
    myHelp: '/mulin/myHelp',
    helpMe: '/mulin/helpMe',
    myPost: '/mulin/myPost',
}

function gotoPage(pageName: string) {
    router.push(pageObj[pageName]);
}


function recharge() {

    if (userInfo.value.isIdCardVerfiy == false) {
        toast('您还未实名认证，请认证后操作');
        setTimeout(() => {
            router.push('/mulin/register')
        }, 1000)
        return;
    }
    RechargeRef.value.open();
}

/**
 * 充值
 */
async function submitRecharge(val: any, close) {

    var pid = await postBeforehandPayNeighborrecharge({ points: parseInt(val), userId: userInfo.value.id });

    //微信支付
    await GOchooseWXPay(pid);
    //刷新数据
    loadMyNeighborCount();

    close();

}
/**
 * 弹出微信支付
 */
async function GOchooseWXPay(dataId: any) {
    toast.loading("");
    const payConf = await payWeJs({
        orderType: 5,//mulin
        dataId: dataId,
        data: "0",
    });
    try {
        const res = await chooseWXPay(payConf);
        toast.success(res);
        setTimeout(() => {
            this.router.push({
                path: `/mulin/my`,
            });
        }, 850);
    } catch (error) {
        if (error == "取消") {
            toast("已取消");
        } else {
            toast("支付失败");
        }
    }
}


/**
 * 联系电话列表
 */
const contactNumberArr = ref([]);

const showContactNumber = ref(false);

function showContactNumberFun() {
    if (contactNumberArr.value.length <= 0) {
        return;
    }
    showContactNumber.value = true;
}

async function contactNumberFun() {
    const data: any = await getByCode('contactNumber') || {};
    if (data) {
        if (data.val) {
            const contactNumberStr: string = data.val || '';
            contactNumberArr.value = contactNumberStr.split(',').filter(item => item);
        } else {
            console.log(111)
        }
    }
}
onMounted(() => {
    onLoad();
    contactNumberFun();
})

const faceAuthRef = ref(null);
const handleFaceAuth = () => {
    // console.log('处理人脸')
    // console.log(faceAuthRef.value);
    // show.value = true;
    // faceAuthRef.value.onClick();
    router.push('/mulin/register')
}

const videoCompressRef = ref(null);

const show = ref(false);
const name = ref('');
const idCard = ref('');
const onSubmit = (values: any) => {

    let videoCompress = videoCompressRef.value;
    console.log(videoCompress.isAvailable)
    if (videoCompress.isAvailable) {
        videoCompress.moveToCameraAVG();
        return;
    }

    faceAuthRef.value.setData(values);
    faceAuthRef.value.onClick();
    show.value = false;
};

const handleClose = () => {
    show.value = false;
}

const faceAuthComplete = (data: any) => {
    console.clear();
    console.log(data)
    if (data.result == false) {
        Dialog.alert({
            title: '提示',
            message: '人脸认证失败，请确保身份信息填写正确，并保证光线充足',
        }).then(() => {
            // on close
        });
    } else {
        loadUserInfo();
    }
}


return (_ctx: any,_cache: any) => {
  const _component_AppImg = _resolveComponent("AppImg")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AppImg, {
            imgSrc: userInfo.value.headImg,
            radius: 50
          }, null, 8, ["imgSrc"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(userInfo.value.tenantName), 1),
            (userInfo.value.isIdCardVerfiy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "已认证"))
              : (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "face-auth-btn",
                  onClick: handleFaceAuth
                }, "点击认证"))
          ]),
          _createElementVNode("div", {
            class: "user-name-edit",
            onClick: goMyUserInfo
          }, "查看并编辑个人资料")
        ])
      ]),
      _createVNode(_component_van_grid, {
        border: false,
        "column-num": 4
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_grid_item, {
            class: "statistics-warp-item",
            onClick: goPoints
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(myNeighborCount.value.myPoint.big), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(myNeighborCount.value.myPoint.small), 1)
              ]),
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, {
            class: "statistics-warp-item",
            onClick: goPoints
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createTextVNode(_toDisplayString(myNeighborCount.value.myOrderPoint.big), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(myNeighborCount.value.myOrderPoint.small), 1)
              ]),
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "statistics-warp-item" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(myNeighborCount.value.pulishCount.big), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(myNeighborCount.value.pulishCount.small), 1)
              ]),
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_van_grid_item, { class: "statistics-warp-item" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createTextVNode(_toDisplayString(myNeighborCount.value.helpCount.big), 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(myNeighborCount.value.helpCount.small), 1)
              ]),
              _hoisted_19
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_van_icon, { name: "diamond" }),
        _createTextVNode(" 充值积分 马上发布新帖 育无忧 "),
        _createVNode(_component_van_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (recharge())),
          round: "",
          size: "mini"
        }, {
          default: _withCtx(() => [
            _createTextVNode("立即充值")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", {
        class: "title-all",
        onClick: showAllMutualAid
      }, [
        _createTextVNode(" 可接单 "),
        _createVNode(_component_van_icon, { name: "arrow" })
      ])
    ]),
    _createVNode(_component_van_swipe, {
      loop: false,
      class: "help-warp",
      "show-indicators": false,
      width: 220,
      height: 120
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loveHelp.value, (item) => {
          return (_openBlock(), _createBlock(_component_van_swipe_item, {
            key: item.id,
            onClick: ($event: any) => (goMutualAid(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, _toDisplayString(findHelpType(item.helptype)), 1),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(item.userName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_van_icon, { name: "diamond" }),
                    _createTextVNode(_toDisplayString(item.point), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, " 需求时间：" + _toDisplayString(new Date(item.needTime)?.format('yyyy年MM月dd日')), 1)
              ])
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell, {
          title: "我已帮助",
          icon: "smile",
          "is-link": "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (gotoPage('myHelp')))
        }),
        _createVNode(_component_van_cell, {
          title: "我的求助",
          icon: "question",
          "is-link": "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (gotoPage('helpMe')))
        }),
        _createVNode(_component_van_cell, {
          title: "我的发帖",
          icon: "comment-circle",
          "is-link": "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (gotoPage('myPost')))
        }),
        _createVNode(_component_van_cell, {
          title: "我的客服",
          onClick: showContactNumberFun,
          icon: "audio",
          "is-link": "",
          value: "工作日 10:00-17:00"
        })
      ]),
      _: 1
    }),
    _createVNode(RechargeView, {
      ref_key: "RechargeRef",
      ref: RechargeRef,
      onSubmitRecharge: submitRecharge,
      payType: 1
    }, null, 512),
    _createVNode(_component_van_popup, {
      closeable: "",
      show: showContactNumber.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showContactNumber).value = $event)),
      position: "bottom",
      style: { maxHeight: '30vh' }
    }, {
      default: _withCtx(() => [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactNumberArr.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "contactNumber-item"
            }, [
              _createElementVNode("a", {
                href: 'tel:' + item
              }, _toDisplayString(item), 9, _hoisted_32)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})